/**
 * Component that conditionally wraps its children with the wrapper component
 * @param {{
 *  condition: boolean,
 *  wrapper: (children: React.ReactNode[]) => React.ReactNode,
 *  children: React.ReactNode[]
 * }} props
 */
const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
